module.exports = __webpack_public_path__ + "static/dinoWood-933211b9b173d2d1faa5ff5dc8d05123.jpg";